<template>
  <div class="lv-checkbox">
    <LvText v-if="title" h6 bold class="mb-8">
      {{ $t(title) }}
    </LvText>
    <label
      class="lv-checkbox__content"
      :class="{ disable }"
      :style="{ 'justify-content': justifyContent }"
      @click.stop="$_onClick()"
    >
      <input
        type="checkbox"
        :value="value"
        :checked="$_isChecked(value)"
        @change="$_onChange($event)"
      />
      <div class="lv-checkbox__icon-wrap" :class="{ h1, h2, h3, h4, h5, disable }">
        <i
          v-if="$_isChecked(value)"
          class="icon-check-box lv-checkbox__icon"
          :class="{ h1, h2, h3, h4, h5 }"
        />
        <i
          v-else-if="isParentSelected"
          class="icon-indeterminate-check-box lv-checkbox__icon"
          :class="{ h1, h2, h3, h4, h5 }"
        />
        <i
          v-else
          class="icon-check-box-outline-blank lv-checkbox__icon"
          :class="{ h1, h2, h3, h4, h5 }"
        />
      </div>
      <LvText
        v-if="text"
        :h2="h1"
        :h3="h2"
        :h4="h3"
        :h5="h4"
        :lightGray="lightGray"
        :noWrap="noWrap"
        :red="red"
        :class="isTextLeft ? 'lv-checkbox__text--left mr-8' : 'ml-8'"
      >
        {{ $t(text) }}
      </LvText>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    exclusive: {
      type: Boolean,
      default: false,
    },
    value: {},
    select: {},
    text: {
      type: String,
    },
    lightGray: {
      type: Boolean,
      default: false,
    },
    h1: {
      type: Boolean,
      default: false,
    },
    h2: {
      type: Boolean,
      default: false,
    },
    h3: {
      type: Boolean,
      default: true,
    },
    h4: {
      type: Boolean,
      default: false,
    },
    h5: {
      type: Boolean,
      default: false,
    },
    justifyContent: {
      type: String,
      default: 'center',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    },
    isParentSelected: {
      type: Boolean,
      default: false,
    },
    isTextLeft: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_isChecked(value) {
      return this.exclusive ? this.select == value : this.select.includes(value);
    },
    $_onChange($event) {
      if (this.disable) return;
      const isChecked = $event.target.checked;
      if (this.exclusive) {
        this.$emit('change', isChecked ? this.value : null);
      } else {
        const resultSelect = [...this.select];
        const tarIndex = resultSelect.findIndex(select => select == this.value);
        if (tarIndex < 0) {
          resultSelect.push(this.value);
        } else {
          resultSelect.splice(tarIndex, 1);
        }
        this.$emit('change', resultSelect);
      }
    },
    $_onClick() {
      return;
    },
  },
};
</script>
